module.exports = __webpack_public_path__ + "static/media/03.084d7208.jpg";